import React, { useState } from 'react';

import { usePhysicalAssetsList } from 'lib/hooks/queries/kiosks/usePhysicalAssetsList';

import Button from 'components/shared/Button/Button';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import PhysicalAsset from 'components/Kiosk/components/PhysicalAsset';
import NotFound from 'components/practice/Dashboard/components/NotFound';

import { PHYSICAL_ASSET_KIND } from '../constants';

const PhysicalAssetTable = ({ kioskId }) => {
  const [show, setShow] = useState({ selectedIndex: null });

  const { data: physicalAssetsData } = usePhysicalAssetsList({
    params: { kioskId },
    dependencies: [kioskId]
  });

  const hasAssets = physicalAssetsData?.data?.length > 0;

  if (!hasAssets) {
    return (
      <>
        <NotFound
          icon="illustration-empty-cpt-codes"
          title="No physical assets added yet"
          description="Physical assets added to this kiosk will appear here."
          createText="Add physical asset"
          onCreate={() => setShow((ps) => ({ ...ps, selectedIndex: 'newItem' }))}
          className="!py-8"
        />
        <PhysicalAsset
          isOpen={!!show.selectedIndex}
          title={`Physical Asset ${show.selectedIndex === 'newItem' ? 'New' : ''}`}
          handleClose={() => setShow((ps) => ({ ...ps, selectedIndex: null }))}
          kioskId={kioskId}
          data={show.selectedIndex === 'newItem' ? { data: {} } : show.selectedIndex}
        />
      </>
    );
  }

  return (
    <>
      <AgTablePage
        defaultColumns={[
          { field: 'id', maxWidth: 80 },
          {
            field: 'physical_asset_kind_id',
            headerName: 'Asset kind',
            valueFormatter: ({ value }) => PHYSICAL_ASSET_KIND[value]
          },
          { field: 'asset_tag' }
        ]}
        onSelectRow={(row) => setShow((ps) => ({ ...ps, selectedIndex: row }))}
        useData={usePhysicalAssetsList}
        title=""
        name="data"
        showExport={false}
        noDisplayButton
        rightHeaderActions={() => (
          <Button
            text="Add physical assets"
            size="small"
            color="primary"
            variant="link"
            onClick={() => setShow((ps) => ({ ...ps, selectedIndex: 'newItem' }))}
            icon="add-circle-mono"
          />
        )}
        noNewButton
        rowStyle={{ cursor: 'pointer' }}
        queryParams={{ kioskId }}
        autoHeight
        className="overflow-y-auto rounded-2xl border border-solid border-neutral-200"
        ModalComponent={PhysicalAsset}
      />
      <PhysicalAsset
        isOpen={!!show.selectedIndex}
        title={`Physical Asset ${show.selectedIndex === 'newItem' ? 'New' : ''}`}
        handleClose={() => setShow((ps) => ({ ...ps, selectedIndex: null }))}
        kioskId={kioskId}
        data={show.selectedIndex === 'newItem' ? { data: {} } : show.selectedIndex}
      />
    </>
  );
};

export default withErrorBoundary(PhysicalAssetTable);
